export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7623.4edb7d3e.jpg";